import React from "react";
import BaseList from "../../components/BaseList";

const getColumns = () => {
  return [
    { field: "nome", header: "Nome do Banco", sortable: true },
  ];
};

export default function DatabaseList() {
  return (
    <BaseList
      titulo="Databases Disponíveis"
      subtitulo="Bancos de dados disponíveis no servidor SQL"
      endpoint="bancos"
      baseRoute="/databases"
      getColumns={getColumns}
      emptyMessage="Nenhum banco de dados encontrado"
      showStatusFilter={false}
      showActions={false}
      allowRowClick={false}
    />
  );
}